import React from 'react';
import PageHead from '../components/PageHead';
import { experience } from '../data/portfolio';
import { MapPin } from 'lucide-react';

const Experience = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 pb-8">
      <PageHead eyebrow="Leadership Experience" title="Career track record" />

      <p className="text-[16px] text-ink-soft mt-2 mb-14 max-w-2xl leading-relaxed">
        Twenty-two years across VP, AVP, and technical leadership roles — building reliability, platforms, and
        engineering culture inside some of the world's largest banks.
      </p>

      <ol className="relative border-l border-border/70 pl-8 space-y-14">
        {experience.map((e, idx) => (
          <li key={idx} className="relative">
            <span className="absolute -left-[41px] top-1.5 w-3 h-3 rounded-full bg-brand ring-4 ring-background pulse-dot" />
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute mb-3">
              {String(idx + 1).padStart(2, '0')} · {e.band}
            </div>
            <h3 className="text-[18px] md:text-xl font-medium tracking-tight leading-snug">{e.title}</h3>
            <div className="mt-1 text-[13.5px] text-ink-soft flex items-center gap-2 flex-wrap">
              <span className="text-foreground font-medium">{e.org}</span>
              <span className="text-ink-mute">•</span>
              <span className="inline-flex items-center gap-1 text-ink-mute">
                <MapPin size={12} /> {e.place}
              </span>
            </div>
            <p className="mt-4 text-[15px] leading-relaxed text-ink-soft">{e.lead}</p>

            {e.bullets.length > 0 && (
              <ul className="mt-5 space-y-3">
                {e.bullets.map((b, i) => (
                  <li key={i} className="text-[15px] leading-relaxed text-ink-soft pl-4 border-l border-border/60">
                    <span className="text-foreground font-medium">{b.h}</span> {b.t}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Experience;
